import * as utils from '../utils/index.js';

const {
    Colors,
    FileTypes,
    Helpers,
    Positions,
    Sizes,
    Transitions,
    Validators,
} = utils;

export default {
    computed: {
        $utils() {
            return {
                ...Helpers,
                Colors,
                FileTypes,
                Positions,
                Sizes,
                Transitions,
            };
        },
        $validators() {
            return Validators;
        },
    },
};
